module.exports = __webpack_public_path__ + "static/manx-a852ad5fb85bf6ff6f1fe3af227b772c.svg";